const localStorBaseKey='uglobally-calc';

const localStorageLoad=(key)=>{
  let storage = localStorage.getItem(localStorBaseKey) || '{}';
  storage = JSON.parse(storage);

  return key ? storage[key] : storage;
}

const localStorageSave=(data)=>{
  const storage = localStorageLoad();

  const newStor = JSON.stringify({...storage,...data});
   localStorage.setItem(localStorBaseKey,newStor);
}




export {
  localStorageSave,
  localStorageLoad
}